// extracted by mini-css-extract-plugin
export default {"valuesDiv":"Values_valuesDiv__vWyGO","cardsWrapper":"Values_cardsWrapper__+o7Nr"};